import React, { Component } from "react";
import * as actionCreators from '../../../modules/actions/index';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import ProfileInfo from './ProfileInfo/ProfileInfo';
import LoginInfo from './LoginInfo/LoginInfo';
import { connect } from 'react-redux';
import './UserProfile.css';
import If from "../../../components/Shared/If";
import { isMobile } from "../../../utils/deviceInfo";
import ProfilePage from "../ProfilePage";

class UserProfile extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  navigateToOfficeMates = () => {
    this.props.history.push('/home/users');
}

  handleProfileUpdateSuccess = (data) => {
    console.log('Updated Profile =>', data);
    this.props.onProfileUpdate(data);
  }

  render() {
    return (<div className={`mb30 userProfileContainer`}>
    {/* <If condition={!isMobile}>
    <Breadcrumb>
            <BreadcrumbItem>
              <a className="officemates-link" onClick={this.navigateToOfficeMates}>
                Enterprise Members
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem active>
              <span className="officemate-name-breadcrumb">
                My Profile
              </span>
              
            </BreadcrumbItem>
          </Breadcrumb>
          </If> */}
              {/* <div className="row mlmr0">
                 <span className="my-profile-title">My Profile</span>
              </div> */}
              {/* <div className="title-hr mt10"></div> */}
              <ProfilePage {...this.props} profileEditSuccsess={this.handleProfileUpdateSuccess}/> 
              {/* <ProfileInfo {...this.props} profileEditSuccsess={this.handleProfileUpdateSuccess}/> */}
              {/* <div className="userProfileLoginInfo">
              </div> */}
            </div>);
  }
}

const mapStateToProps = state => {
	return {
     user: state.user.profile,
	}
}

const mapDispatchToProps = dispatch => {
	return {
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);